import { createSlice } from '@reduxjs/toolkit'
import { fetchInstanceEvents } from '../services/fetchInstanceEvents'
import { InstanceEventsSchema } from '../types/InstanceEvent'

const initialState: InstanceEventsSchema = {
	limit: 10,
	error: '',
	isLoading: false,

	paginatedInstanceEvents: {
		currentPage: 1,
		items: []
	},
	filter: {},
	queryFilter: {},
	sort: {}
}

const instanceEventsSlice = createSlice({
	name: 'instanceEvents',
	initialState,
	reducers: {
		setPage: (state, action) => {
			state.paginatedInstanceEvents.currentPage = action.payload
		},
		resetPage: (state) => {
			state.paginatedInstanceEvents.currentPage = 1
		},
		setLimit: (state, action) => {
			state.limit = action.payload
		},
		setSort: (state, action) => {
			state.sort.sort = action.payload
		},
		setDirection: (state, action) => {
			state.sort.direction = action.payload
		},
		setUpdateTimeFrom: (state, action) => {
			state.filter.updateTimeFrom = action.payload
		},
		setUpdateTimeTo: (state, action) => {
			state.filter.updateTimeTo = action.payload
		},
		setQueryFilter: (state) => {
			state.queryFilter = { ...state.filter }
		},
		removeFilter: (state, action) => {
			const filterName: keyof typeof state.queryFilter = action.payload
			delete state.filter[filterName]
			delete state.queryFilter[filterName]
		},
		resetFilter: (state) => {
			state.filter = {}
			state.queryFilter = {}
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchInstanceEvents.pending, (state) => {
				state.isLoading = true
				state.error = ''
			})
			.addCase(fetchInstanceEvents.fulfilled, (state, action) => {
				const instanceEvents = action.payload

				state.paginatedInstanceEvents.items = instanceEvents
				state.paginatedInstanceEvents.totalCount = instanceEvents?.length ?? 0
				state.isLoading = false
			})
			.addCase(fetchInstanceEvents.rejected, (state, action) => {
				state.isLoading = false
				state.error = action.payload
			})
	}
})

export const { actions: instanceEventsActions } = instanceEventsSlice
export const { reducer: instanceEventsReducer } = instanceEventsSlice
